import {INTELLIGENCE} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/intelligence/index.vue'),
    name: INTELLIGENCE,
    path: 'intelligence',
    meta: {
        name: INTELLIGENCE,
        title: '威胁情报库'
    }
};